var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Box, Button, Flex, Icon, Input, Text } from '@chakra-ui/react';
import { MdClose } from '@react-icons/all-files/md/MdClose';
import { observer } from 'mobx-react';
import React from 'react';
import { ScaleLoader } from 'react-spinners';
import { AppColor, FontSize } from '../const/AppDefaults';
import { StoreContext } from '../uistore/Rootstore';
let AddMiscContact = class AddMiscContact extends React.Component {
    constructor() {
        super(...arguments);
        this.boxref = null;
        this.adjustx = 0;
        this.adjusty = 0;
        this.upcb = () => {
            const rstore = this.context;
            rstore.addMiscStore.setDragging(false);
        };
        this.mousemove = (e) => {
            const rstore = this.context;
            if (rstore.addMiscStore.dragging) {
                // lets move this dialog 
                rstore.addMiscStore.setTop(e.clientY - this.adjusty);
                rstore.addMiscStore.setLeft(e.clientX - this.adjustx);
            }
        };
    }
    componentDidMount() {
        window.addEventListener("mouseup", this.upcb);
        window.addEventListener("mousemove", this.mousemove);
    }
    componentWillUnmount() {
        window.removeEventListener("mouseup", this.upcb);
        window.removeEventListener("mousemove", this.mousemove);
    }
    render() {
        const rstore = this.context;
        if (!rstore.addMiscStore.show) {
            return React.createElement(React.Fragment, null);
        }
        return React.createElement(Box, { pos: 'relative', "object-chooser": 'miscbox', ref: (ref) => this.boxref = ref, bg: 'white', borderRadius: '4px', className: 'floating-dialog', zIndex: 5000, cursor: rstore.addMiscStore.dragging ? 'grabbing' : '', onMouseDown: (e) => {
                var _a, _b;
                const tgt = e.target;
                if (tgt.getAttribute("miscbox")) {
                    rstore.addMiscStore.setDragging(true);
                    if (this.boxref) {
                        this.adjustx = e.clientX - ((_a = this.boxref) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().left);
                        this.adjusty = e.clientY - ((_b = this.boxref) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().top);
                    }
                }
            }, position: 'fixed', left: rstore.addMiscStore.left + "px", top: rstore.addMiscStore.top + "px", width: rstore.addMiscStore.width + "px", height: (rstore.addMiscStore.height) + "px" },
            React.createElement(Flex, { "border-bottom": '1px solid lightgray', padding: '10px', align: 'center', "object-chooser": 'miscbox', height: "35px", width: '100%' },
                React.createElement(Text, { "object-chooser": 'miscbox', ml: '5px', fontWeight: 'bold', color: AppColor.LinkNameColor, fontSize: FontSize.LinkName, w: '90%' }, "Add New Event"),
                React.createElement(Flex, { "object-chooser": 'miscbox', w: '10%', justify: 'flex-end' },
                    React.createElement(Icon, { "object-chooser": 'miscbox', ml: '20px', as: MdClose, color: AppColor.ResetFilter, h: '25px', w: '25px', _hover: { cursor: 'pointer' }, onClick: (e) => {
                            rstore.addMiscStore.setShow(false);
                        }, className: 'message-option-button' }))),
            React.createElement(Input, { w: '80%', m: '15px', variant: 'flushed', placeholder: 'Name', defaultValue: rstore.addMiscStore.name, onChange: (e) => {
                    rstore.addMiscStore.setName(e.currentTarget.value);
                } }),
            React.createElement(Input, { w: '80%', m: '15px', variant: 'flushed', placeholder: 'Email', defaultValue: rstore.addMiscStore.email, onChange: (e) => {
                    rstore.addMiscStore.setEmail(e.currentTarget.value);
                } }),
            React.createElement(Input, { w: '80%', m: '15px', variant: 'flushed', placeholder: 'Phone Number', type: 'number', defaultValue: rstore.addMiscStore.number, onChange: (e) => {
                    rstore.addMiscStore.setNumber(e.currentTarget.value);
                } }),
            React.createElement(Input, { w: '80%', m: '15px', variant: 'flushed', placeholder: 'Hint for communication password', defaultValue: rstore.addMiscStore.hint, onChange: (e) => {
                    rstore.addMiscStore.setHint(e.currentTarget.value);
                } }),
            React.createElement(Input, { w: '80%', m: '15px', variant: 'flushed', placeholder: 'Communication Passcode', defaultValue: rstore.addMiscStore.password, onChange: (e) => {
                    rstore.addMiscStore.setPassword(e.currentTarget.value);
                } }),
            React.createElement(Flex, { align: 'center', justify: 'flex-end', pos: 'absolute', w: '100%', bottom: '5px' },
                !rstore.addMiscStore.adding && React.createElement(Button, { onClick: () => {
                    }, variant: 'unstyled' }, "Add"),
                rstore.addMiscStore.adding && React.createElement(ScaleLoader, { color: 'green' })));
    }
};
AddMiscContact.contextType = StoreContext;
AddMiscContact = __decorate([
    observer
], AddMiscContact);
export { AddMiscContact };
